import { Metadata } from 'next'

const title = 'Why Travelers Choose Ship&Play'
const description =
  'Discover the benefits of Ship&Play, the easiest way to ship your luggage, family ' +
  'essentials, and sports equipment.'
const url = 'https://www.shipplay.com/guarantee'
const image = 'https://media.shipplay.com/ship-sticks-og-image.png'

const metadata: Metadata = {
  title,
  description,
  alternates: {
    canonical: url,
  },
  openGraph: {
    type: 'website',
    url,
    siteName: 'Ship&Play',
    title,
    description,
    images: [
      {
        url: image,
        width: 1200,
        height: 630,
        alt: 'Why travelers choose Ship&Play — the guarantee behind every shipment',
      },
    ],
  },
  twitter: {
    card: 'summary_large_image',
    title,
    description,
    images: [image],
  },
}

export default metadata
